<div class="modal-dialog modal-fullscreen">
  <div class="modal-content">
    <div class="modal-header" *ngIf="!hide">
      <h5 class="modal-title" i18n><strong>Infrações por Data</strong><span *ngIf="params?.spotCode"> — Ponto {{ params.spotCode }}</span></h5>
      <button type="button" (click)="onClose()"
        class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>

    <div class="modal-body p-0" *ngIf="!loading; else loadingBlock">
      <hr class="mt-0">
      <div class="container">
        <div class="row no-gutters" *ngIf="!hide">
          <div class="col-md-12">

            <div class="table-flex__header">
              <p class="w-25" i18n>Período</p>
              <p class="w-10"></p>
              <p class="w-15" i18n>Em processamento</p>
              <p class="w-15" i18n>Válidas</p>
              <p class="w-15" i18n>Inválidas</p>
              <p class="w-10" i18n>Total</p>
              <p class="w-10"></p>
            </div>

            <ng-container *ngIf="violationsByDate.length === 0 && noDataFound">
              <div class="text-center p-4" i18n>Nenhum dado encontrado para o
                período selecionado.</div>
            </ng-container>

            <div class="table-flex__item" *ngFor="let item of violationsByDate"
              [class.collapsed]="item.collapse">

              <!-- Linha da data -->
              <div class="table-flex__row bg-gray--250">
                <p class="w-25">{{ item.date | moment: 'DD/MM/YYYY' }}</p>
                <p class="w-10"></p>

                <p class="w-15">
                  <a class="no-href" *ngIf="item.inProcess > 0"
                    (click)="openDetails(item.date, 'inProcess')">
                    {{ formatQty(item.inProcess, item.total) }}
                  </a>
                  <ng-container *ngIf="item.inProcess === 0">0</ng-container>
                </p>

                <p class="w-15">
                  <a class="no-href" *ngIf="item.valid > 0"
                    (click)="openDetails(item.date, 'valid')">
                    {{ formatQty(item.valid, item.total) }}
                  </a>
                  <ng-container *ngIf="item.valid === 0">0</ng-container>
                </p>

                <p class="w-15">
                  <a class="no-href" *ngIf="item.invalid > 0"
                    (click)="openDetails(item.date, 'invalid')">
                    {{ formatQty(item.invalid, item.total) }}
                  </a>
                  <ng-container *ngIf="item.invalid === 0">0</ng-container>
                </p>

                <p class="w-10">
                  <a class="no-href" (click)="openDetails(item.date)">{{
                    item.total }}</a>
                </p>

                <div class="w-10 text-center">
                  <button class="btn btn-sm btn-icon-block"
                    [ngClass]="{ 'btn-secondary': !item.collapse, 'btn-outline-secondary': item.collapse }"
                    (click)="toggleDate(item)" *ngIf="item.total > 0">
                    <span *ngIf="item.loadingTree"
                      class="spinner-border spinner-border-sm"></span>
                    <i class="material-icons"
                      *ngIf="!item.loadingTree && !item.collapse">unfold_less</i>
                    <i class="material-icons"
                      *ngIf="!item.loadingTree && item.collapse">unfold_more</i>
                  </button>
                </div>
              </div>

              <!-- Tree da data (spots → lanes → regulations → reasons) -->
              <ng-container *ngIf="!item.collapse && item.tree">

                <div class="table-flex__item"
                  *ngFor="let spot of item.tree.spots"
                  [class.collapsed]="spot.collapse">
                  <div class="table-flex__row bg-gray--200">
                    <p class="w-25 w--push-3" i18n-appTooltip
                      [appTooltip]="'Ponto: ' + spot.spotCode + ' - ' + spot.spotDescription">
                      {{ spot.spotCode }}
                      {{ (spot.spotDescription?.length > 20) ? ' - ' +
                      (spot.spotDescription | slice:0:20) + '...' : ' - ' +
                      (spot.spotDescription || '') }}
                    </p>
                    <p class="w-10"></p>

                    <p class="w-15">
                      <a class="no-href"
                        *ngIf="spot.quantityInProcessing !== '0/0.00%'"
                        (click)="openDetails(item.date, 'inProcess')">
                        {{ spot.quantityInProcessing }}
                      </a>
                      <ng-container
                        *ngIf="spot.quantityInProcessing === '0/0.00%'">0</ng-container>
                    </p>

                    <p class="w-15">
                      <a class="no-href" *ngIf="spot.validQuantity > 0"
                        (click)="openDetails(item.date, 'valid')">
                        {{ formatQty(spot.validQuantity, spot.total) }}
                      </a>
                      <ng-container
                        *ngIf="spot.validQuantity === 0">0</ng-container>
                    </p>

                    <p class="w-15">
                      <a class="no-href" *ngIf="spot.invalidQuantity > 0"
                        (click)="openDetails(item.date, 'invalid')">
                        {{ formatQty(spot.invalidQuantity, spot.total) }}
                      </a>
                      <ng-container
                        *ngIf="spot.invalidQuantity === 0">0</ng-container>
                    </p>

                    <p class="w-10">
                      <a class="no-href" (click)="openDetails(item.date)">{{
                        spot.total }}</a>
                    </p>

                    <div class="w-10 text-center">
                      <button class="btn btn-sm btn-icon-block"
                        [ngClass]="{ 'btn-secondary': spot.collapse, 'btn-outline-secondary': !spot.collapse }"
                        (click)="toggleCollapse(spot)" *ngIf="spot.total > 0">
                        <i class="material-icons"
                          *ngIf="spot.collapse">unfold_less</i>
                        <i class="material-icons"
                          *ngIf="!spot.collapse">unfold_more</i>
                      </button>
                    </div>
                  </div>

                  <!-- Lanes -->
                  <ng-container *ngIf="!spot.collapse">
                    <div class="table-flex__item"
                      *ngFor="let lane of spot.lanes">
                      <div class="table-flex__row bg-gray--100">
                        <p class="w-25 w--push-5" i18n-appTooltip
                          [appTooltip]="lane.laneCode + ' - Fx' + lane.laneNumber + ' (Ponto ' + spot.spotCode + ')'">
                          {{ lane.laneCode }} - Fx {{ lane.laneNumber }} (Ponto
                          {{ spot.spotCode }})
                        </p>
                        <p class="w-10">
                          <button class="btn btn-sm btn-icon-block"
                            (click)="toggleCollapse(lane)"
                            *ngIf="lane.total > 0">
                            <i class="material-icons"
                              *ngIf="lane.collapse">expand_more</i>
                            <i class="material-icons"
                              *ngIf="!lane.collapse">expand_less</i>
                          </button>
                        </p>

                        <p class="w-15">
                          <a class="no-href"
                            *ngIf="lane.quantityInProcessing !== '0/0.00%'"
                            (click)="openDetails(item.date, 'inProcess', lane.laneCode)">
                            {{ lane.quantityInProcessing }}
                          </a>
                          <ng-container
                            *ngIf="lane.quantityInProcessing === '0/0.00%'">0</ng-container>
                        </p>

                        <p class="w-15">
                          <a class="no-href" *ngIf="lane.validQuantity > 0"
                            (click)="openDetails(item.date, 'valid', lane.laneCode)">
                            {{ formatQty(lane.validQuantity, lane.total) }}
                          </a>
                          <ng-container
                            *ngIf="lane.validQuantity === 0">0</ng-container>
                        </p>

                        <p class="w-15">
                          <a class="no-href" *ngIf="lane.invalidQuantity > 0"
                            (click)="openDetails(item.date, 'invalid', lane.laneCode)">
                            {{ formatQty(lane.invalidQuantity, lane.total) }}
                          </a>
                          <ng-container
                            *ngIf="lane.invalidQuantity === 0">0</ng-container>
                        </p>

                        <p class="w-10">
                          <a class="no-href"
                            (click)="openDetails(item.date, null, lane.laneCode)">
                            {{ lane.total }}
                          </a>
                        </p>
                        <p class="w-10"></p>
                      </div>

                      <!-- Regulations -->
                      <ng-container *ngIf="!lane.collapse">
                        <div class="table-flex__item"
                          *ngFor="let reg of lane.regulations">
                          <div class="table-flex__row">
                            <p class="w-25"></p>
                            <p class="w-10">
                              <span i18n-appTooltip
                                [appTooltip]="reg.regulationDescription"
                                class="d-inline-flex align-items-center">
                                <i
                                  class="material-icons text-light mr-2">info</i>
                                {{ reg.regulationCode }}
                              </span>
                            </p>

                            <p class="w-15">
                              <a class="no-href"
                                *ngIf="reg.quantityInProcessing !== '0/0.00%'"
                                (click)="openDetails(item.date, 'inProcess', lane.laneCode, reg.regulationId)">
                                {{ reg.quantityInProcessing }}
                              </a>
                              <ng-container
                                *ngIf="reg.quantityInProcessing === '0/0.00%'">0</ng-container>
                            </p>

                            <p class="w-15">
                              <a class="no-href" *ngIf="reg.validQuantity > 0"
                                (click)="openDetails(item.date, 'valid', lane.laneCode, reg.regulationId)">
                                {{ formatQty(reg.validQuantity, reg.total) }}
                              </a>
                              <ng-container
                                *ngIf="reg.validQuantity === 0">0</ng-container>
                            </p>

                            <p class="w-15">
                              <a class="no-href" *ngIf="reg.invalidQuantity > 0"
                                (click)="openDetails(item.date, 'invalid', lane.laneCode, reg.regulationId)">
                                {{ formatQty(reg.invalidQuantity, reg.total) }}
                              </a>
                              <ng-container
                                *ngIf="reg.invalidQuantity === 0">0</ng-container>

                              <button class="btn btn-sm btn-icon-block"
                                (click)="toggleCollapse(reg)"
                                *ngIf="reg.reasons?.length > 0">
                                <i class="material-icons"
                                  *ngIf="reg.collapse">expand_more</i>
                                <i class="material-icons"
                                  *ngIf="!reg.collapse">expand_less</i>
                              </button>
                            </p>

                            <p class="w-10">
                              <a class="no-href"
                                (click)="openDetails(item.date, null, lane.laneCode, reg.regulationId)">
                                {{ reg.total }}
                              </a>
                            </p>
                            <p class="w-10"></p>
                          </div>

                          <!-- Reasons -->
                          <ng-container *ngIf="!reg.collapse && reg.reasons">
                            <div class="table-flex__row"
                              *ngFor="let reason of reg.reasons">
                              <p class="w-25"></p>
                              <p class="w-10"></p>
                              <p class="w-15"></p>
                              <p class="w-15"></p>
                              <p class="w-15">{{ reason.reasonCode }} - {{
                                reason.reasonDescription }}</p>
                              <p class="w-10">
                                <a class="no-href"
                                  (click)="openDetails(item.date, null, lane.laneCode, reg.regulationId)">
                                  {{ reason.total }}
                                </a>
                              </p>
                              <div class="w-10 pr-3">
                                <div class="progress" i18n-appTooltip
                                  [appTooltip]="'Representa ' + getProgressWidth(reason.invalidQuantity, reg.invalidQuantity) + ' das inválidas desta regra'">
                                  <div class="progress-bar bg-info"
                                    role="progressbar"
                                    [style.width]="getProgressWidth(reason.invalidQuantity, reg.invalidQuantity)"
                                    [attr.aria-valuenow]="reason.invalidQuantity"
                                    aria-valuemin="0"
                                    [attr.aria-valuemax]="reg.invalidQuantity">
                                    {{ getProgressWidth(reason.invalidQuantity,
                                    reg.invalidQuantity) }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-container>

                        </div>
                      </ng-container>
                    </div>
                  </ng-container>

                </div>

              </ng-container>
            </div>

          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <app-pagination-url
              [currentRoute]="'reportViolationByDate'"
              [service]="paginateByDateAdapter"
              [pageSize]="10"
              [params]="params"
              (items)="setViolationsByDate($event)">
            </app-pagination-url>
          </div>
        </div>
      </div>
    </div>

    <ng-template #loadingBlock>
      <div class="loading-page">
        <div class="loading-spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
